<script setup>
import { computed } from 'vue';
import FordButton from '@/components/FordButton.vue';
import EventSection from './EventSection.vue';
import statusCodes from './statusCodes';

const props = defineProps({
  event: Object,
  statuses: Object,
});

const loading = computed(() => props.statuses.cancelStatus === statusCodes.loading);

const noMoreSessionsLeft = computed(() => {
  const appointments = props.event?.configSME?.appointments;
  return appointments.every((appt) => appt.available === 0);
});

const emit = defineEmits(['reschedule']);

const reschedule = (payload) => emit('reschedule', payload);
const cancel = (payload) => emit('cancel', payload);
</script>
<template>
  <div class="tablet:text-center bg-ford-gray-light">
    <form @submit.prevent="submitEmail">
      <h1 class="
        text-[1.125rem] tablet:text-[2.125rem]
        font-FordAntennaMed
        mb-[1.875rem]
        max-w-[53rem]
        mx-auto
      ">
        Reschedule Your Appointment
      </h1>
      <p
        class="
          text-[.875rem] tablet:text-[1rem]
          text-ford-gray-darker
          mb-[1.875rem]
          max-w-[48rem]
          mx-auto
        ">
        Need to reschedule your appointment with Ford Pro™? Click below to adjust your current
        appointment. If you need to cancel your appointment, select the cancel button.
      </p>

      <div
        class="
          flex
          tablet:justify-center
          flex-col
          tablet:flex-row
          tablet:w-full
          w-1/2
        "
      >
        <ford-button
          class="mb-[3rem]"
          :prevent-default="false"
          :disabled="noMoreSessionsLeft"
          @method="reschedule"
          disabled-tooltip="Unfortunately, all appointment sessions are booked.
            You can choose to keep your existing appointment or cancel the appointment."
        >

          Reschedule
        </ford-button>

        <ford-button class="mb-[3rem] tablet:ml-[2rem]" :prevent-default="false" @method="cancel">
          <img v-if="loading"
            :src="require('@/assets/img/spinner.svg')" alt="spinner"
          />
          <span v-else>Cancel Appointment</span>
        </ford-button>
      </div>
    </form>
    <hr class="
      mx-auto
      max-w-[50rem]
      mb-[2.5rem] hidden tablet:block
      border-[#707070]
    " />
    <event-section :event="event" />
  </div>
</template>
